export default function formatToIndianCurrency(amount, type = 'currency') {
  // Check the type: either format as currency or just as a number
  if (type === 'number') {
      // Format the number without the currency symbol
      return new Intl.NumberFormat('en-IN', {
          style: 'decimal', // Use 'decimal' style for numbers without a symbol
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
      }).format(amount);
  } else {
      // Default: format the number as currency with ₹ symbol
      return new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
      }).format(amount);
  }
}